(function () {
  var STAGGER_STEP = 50;
  var STAGGER_START = 10;

  function resetFlyoutChildStagger(flyout) {
    flyout.querySelectorAll('.dropdown__flyout__item > .navlink--child[data-stagger]').forEach(function (link, index) {
      link.style.transitionDelay = index * STAGGER_STEP + STAGGER_START + 'ms';
    });
  }

  function resetGrandchildStagger(flyout) {
    flyout.querySelectorAll('.dropdown__flyout__panel .navlink--grandchild').forEach(function (link) {
      link.classList.remove('is-staggered');
      link.style.transitionDelay = '0ms';
    });
  }

  function staggerGrandchildPanel(item) {
    var panel = item.querySelector('[data-dropdown-flyout-panel]');
    if (!panel) return;

    var links = panel.querySelectorAll('.navlink--grandchild');

    links.forEach(function (link) {
      link.classList.remove('is-staggered');
      link.style.transitionDelay = '0ms';
    });

    void panel.offsetWidth;

    links.forEach(function (link, index) {
      link.style.transitionDelay = index * STAGGER_STEP + STAGGER_START + 'ms';
      link.classList.add('is-staggered');
    });
  }

  function deactivateFlyoutPanels(flyout, itemsWithChildren) {
    itemsWithChildren.forEach(function (item) {
      item.classList.remove('is-active');
    });
    resetGrandchildStagger(flyout);
  }

  function activateFlyoutItem(flyout, itemsWithChildren, item) {
    itemsWithChildren.forEach(function (other) {
      other.classList.remove('is-active');
    });

    resetGrandchildStagger(flyout);
    item.classList.add('is-active');
    staggerGrandchildPanel(item);
  }

  function initGrandchildFlyoutMenus() {
    document.querySelectorAll('[data-dropdown-flyout]:not([data-flyout-initialized])').forEach(function (flyout) {
      flyout.setAttribute('data-flyout-initialized', 'true');
      resetFlyoutChildStagger(flyout);
      resetGrandchildStagger(flyout);

      var menuItem = flyout.closest('.menu__item');
      if (menuItem) {
        menuItem.addEventListener('mouseenter', function () {
          resetFlyoutChildStagger(flyout);
        });
      }

      var itemsWithChildren = flyout.querySelectorAll('.dropdown__flyout__item--has-children');
      var allItems = flyout.querySelectorAll('.dropdown__flyout__item');

      allItems.forEach(function (item) {
        var link = item.querySelector('.navlink--child');
        if (!link) return;

        item.addEventListener('mouseenter', function () {
          if (item.classList.contains('dropdown__flyout__item--has-children')) {
            activateFlyoutItem(flyout, itemsWithChildren, item);
          } else {
            deactivateFlyoutPanels(flyout, itemsWithChildren);
          }
        });

        if (!item.classList.contains('dropdown__flyout__item--has-children')) return;

        link.addEventListener('click', function (event) {
          if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

          if (!item.classList.contains('is-active')) {
            event.preventDefault();
            activateFlyoutItem(flyout, itemsWithChildren, item);
          }
        });

        link.addEventListener('touchstart', function (event) {
          if (!item.classList.contains('is-active')) {
            event.preventDefault();
            activateFlyoutItem(flyout, itemsWithChildren, item);
          }
        }, { passive: false });
      });

      flyout.addEventListener('mouseleave', function () {
        deactivateFlyoutPanels(flyout, itemsWithChildren);
      });
    });
  }

  function refreshFlyoutStagger() {
    document.querySelectorAll('[data-dropdown-flyout]').forEach(function (flyout) {
      resetFlyoutChildStagger(flyout);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGrandchildFlyoutMenus();
    window.requestAnimationFrame(refreshFlyoutStagger);
  });
  document.addEventListener('shopify:section:load', function () {
    initGrandchildFlyoutMenus();
    window.requestAnimationFrame(refreshFlyoutStagger);
  });
})();
